import { IconButton } from '@mui/material';
import { FC, useMemo } from 'react';

import { CommentFilledIcon, CommentIcon } from '../../assets/icons';
import { theme } from '../../theme/theme';

export interface DropdownCommentIconProps {
  disabled: boolean;
  hasComments: boolean;
  error: boolean;
  hover?: boolean;
}

export const DropdownCommentIcon: FC<DropdownCommentIconProps> = ({
  disabled,
  hasComments,
  error,
  hover = true,
}) => {
  const styles = useMemo(() => {
    if (hasComments) {
      return {
        color: error ? theme.palette.error.main : theme.palette.primary.main,
        ':hover': {
          color: error ? theme.palette.error.main : theme.palette.primary.main,
        },
      };
    }
    return {
      color: error ? theme.palette.error.main : theme.palette.text.primary,
      ...(hover && {
        '.GridRow:hover &, .GridRowItem:hover &, .MuiDataGrid-row.Mui-hovered &': {
          '&:not(.Mui-disabled)': {
            color: error ? theme.palette.error.main : theme.palette.primary.main,
          },
        },
      }),
    };
  }, [error, hasComments, hover]);

  return (
    <IconButton
      className="icon-Comments"
      disabled={disabled}
      sx={(theme) => ({
        ...styles,
        '&.Mui-disabled': {
          color: error ? theme.palette.error.main : theme.palette.text.secondary,
        },
      })}
    >
      {hasComments ? <CommentFilledIcon /> : <CommentIcon />}
    </IconButton>
  );
};
